import { Link } from 'react-router-dom';
import { glenfallsCabin, featuredProperties } from '../../../mocks/properties';

const larkLodge = featuredProperties.find((p) => p.id === 3)!;
const stagRidge = featuredProperties.find((p) => p.id === 1)!;

const SHOWCASE = [glenfallsCabin, larkLodge, stagRidge];

export default function FeaturedProperties() {
  return (
    <section className="bg-[#FAFAF8] py-28 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Curated Collection</p>
            <h2 className="font-cormorant text-5xl md:text-6xl text-[#1A1A18] font-light leading-none">
              Featured<br />
              <em className="italic">Properties</em>
            </h2>
          </div>
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed max-w-sm">
            Explore a curated selection of cabins in Highlands, North Carolina, including luxury stays, pet-friendly cabins, and properties located near waterfalls and hiking trails.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {SHOWCASE.map((property) => (
            <article
              key={property.id}
              className="group relative overflow-hidden rounded-2xl cursor-pointer"
            >
              <div className="overflow-hidden rounded-2xl">
                <img
                  src={property.image}
                  alt={`${property.name} — pet-friendly cabin in Highlands, North Carolina`}
                  className="w-full h-72 object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>

              <div className="pt-5 pb-2">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[#6B8C7D] text-xs tracking-widest uppercase font-jost">{property.type}</span>
                  <div className="flex items-center gap-1">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-[#C9A96E] text-xs" />
                    </div>
                    <span className="text-[#1A1A18] text-xs font-jost font-medium">5.0</span>
                  </div>
                </div>
                <h3 className="font-cormorant text-2xl text-[#1A1A18] font-medium leading-tight mb-1">
                  {property.name}
                </h3>
                <p className="text-[#9C9890] text-xs font-jost mb-3">{property.location}</p>
                <p className="text-[#5C5850] text-sm font-jost leading-relaxed line-clamp-2 mb-2">
                  {property.description}
                </p>
                {property.id === 0 && (
                  <p className="text-[#6B8C7D] text-xs font-jost leading-relaxed mb-4 italic">
                    Located near Glen Falls, one of the most visited waterfalls in Highlands, NC.
                  </p>
                )}
                {property.id !== 0 && <div className="mb-4" />}
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    {property.petFriendly && (
                      <span className="flex items-center gap-1 text-[#6B8C7D] text-xs font-jost">
                        <div className="w-3 h-3 flex items-center justify-center"><i className="ri-paw-print-line text-xs" /></div>
                        Pet Friendly
                      </span>
                    )}
                    {property.nearWaterfall && (
                      <span className="flex items-center gap-1 text-[#6B8C7D] text-xs font-jost">
                        <div className="w-3 h-3 flex items-center justify-center"><i className="ri-water-flash-line text-xs" /></div>
                        Near Falls
                      </span>
                    )}
                  </div>
                  <a
                    href={property.airbnbUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#2D4A3E] text-xs font-jost font-medium border border-[#2D4A3E]/30 px-4 py-1.5 rounded-full hover:bg-[#2D4A3E] hover:text-white transition-all whitespace-nowrap cursor-pointer"
                  >
                    View on Airbnb
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-14">
          <Link
            to="/best-luxury-cabins"
            className="inline-flex items-center gap-3 border border-[#2D4A3E] text-[#2D4A3E] text-xs tracking-[0.2em] uppercase font-jost px-10 py-4 rounded-full hover:bg-[#2D4A3E] hover:text-white transition-all cursor-pointer whitespace-nowrap"
          >
            View All Cabins
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
